import React, { Fragment, Component } from "react";
import Breadcrumb from "../../../components/common/breadcrumb";
import ProductInfo from "./productForm";
import ProductService from "../../../services/productService";
import BrandCategoryService from "../../../services/brandCategoryService";
// import store from "store";

class CreateProduct extends Component {
  state = {
    infoData: {},
    brandsList: [],
    categoryList: [],
    info: { pdfFileUrl: "" },
  };
  componentWillMount() {
    console.log("-----DataTableComponent---");
    // this.setState({ infoData: data });
    // this.setState({ trainings: store.get("myCart") });
    BrandCategoryService.fetchBrandCategoryInfo().then((response) => {
      if (!response.error) {
        this.setState({ brandsList: response?.data?.brandList });
        this.setState({ categoryList: response?.data?.categoryList });
      }
    });
  }
  addProductInfo = (data) => {
    const {
      pictursList,
      description,
      active,
      selectedBrandId,
      selectedCategoryId,
      selectedSubCategory,
      selectedBrandUrl,
      selectedCategoryUrl,
      pdfFileName,
      pdfFileUrl,
    } = this.state;
    if (!selectedBrandId) {
      this.setState({ selectedBrandError: true });
      return;
    }
    if (!selectedCategoryId) {
      this.setState({ selectedCategoryError: true });
      return;
    }
    if (!selectedSubCategory) {
      this.setState({ selectedSubCategoryError: true });
      return;
    }
    data["pictursList"] = pictursList;
    data["description"] = description;
    data["active"] = active;
    data["brandUrl"] = selectedBrandUrl;
    data["categoryUrl"] = selectedCategoryUrl;
    data["brandId"] = selectedBrandId;
    data["categoryId"] = selectedCategoryId;
    data["subCategory"] = selectedSubCategory;
    data["pdfFileName"] = pdfFileName;
    data["pdfFileUrl"] = pdfFileUrl;
    data["fullUrl"] =
      selectedBrandUrl + "/" + selectedCategoryUrl + "/" + data["sUrl"];

    this.setState({ loader: true });
    ProductService.addProductInfo(data, "POST").then((response) => {
      if (!response.error) {
        this.props.history.push("/products/all");
      }
      // //console.log("response", response[0] === "{");
      // toast.success("List fetched successfully!");
      // if (response[0] === "{") {
      //   this.setState({ infoData: [JSON.parse(response)] });
      // } else if (response[0] === "[") {
      //   this.setState({ infoData: JSON.parse(response) });
      // } else {
      //   this.setState({ infoData: [] });
      // }
    });
  };
  onChangeUrl2 = (name, url) => {
    if ((name && name !== "") || (url && url !== "")) {
      console.log({ url });
      var { info, urlEdit } = this.state;
      var stringUrl = "";
      var urlEdit1 = false;
      if (name && !urlEdit) {
        stringUrl = name.toLowerCase();
      } else if (url) {
        stringUrl = url.toLowerCase();
        urlEdit1 = true;
      }
      stringUrl = stringUrl.replace(/ /g, "-");
      stringUrl = stringUrl.replace(/,/g, "-");
      stringUrl = stringUrl.replace(/__/g, "-");
      stringUrl = stringUrl.replace(/_/g, "-");
      stringUrl = stringUrl.replace(/--/g, "-");
      if (info) {
        info["sUrl"] = stringUrl;
      } else {
        info = { sUrl: stringUrl };
      }
      this.setState({ info: info, urlEdit: urlEdit1 });
    }
  };

  onChangeUrl = (name, url) => {
    if (
      (name && name !== "") ||
      (url && url !== "undefined") ||
      (url === "" && url !== "undefined")
    ) {
      var { info, urlEdit } = this.state;
      console.log({ name, url, urlEdit });
      var stringUrl = "";
      var urlEdit1 = false;
      if (name && !urlEdit) {
        stringUrl = name.toLowerCase();
        urlEdit1 = urlEdit || urlEdit1;
      } else if (url && url !== "undefined") {
        stringUrl = url.toLowerCase();
        urlEdit1 = true;
      } else if (url === "" && url !== "undefined") {
        stringUrl = url;
        urlEdit1 = false;
      } else {
        stringUrl = info["sUrl"] || "";
        urlEdit1 = urlEdit || urlEdit1;
      }
      stringUrl = stringUrl.replace(/ /g, "_");
      stringUrl = stringUrl.replace(/,/g, "_");
      stringUrl = stringUrl.replace(/__/g, "_");
      console.log({ stringUrl, urlEdit1 });
      if (info) {
        info["sUrl"] = stringUrl;
      } else {
        info = { sUrl: stringUrl };
      }
      this.setState({ info: info, urlEdit: urlEdit1 });
    }
  };
  render() {
    const {
      info,
      infoData,
      brandsList,
      categoryList,
      selectedBrandError,
      selectedCategoryError,
      selectedSubCategoryError,
      selectedCategoryId,
    } = this.state;
    // const propsDaterangePicker = {
    //   changeRangePicker: (startDate, endDate) => {
    //     //console.log({ startDate });
    //     //console.log({ endDate });
    //   }
    // };
    const productInfoProps = {
      selectedBrandError: selectedBrandError,
      selectedCategoryError: selectedCategoryError,
      selectedSubCategoryError: selectedSubCategoryError,
      selectedCategoryId: selectedCategoryId,
      active: this.state.active,
      pictursList: this.state.pictursList,
      onProductImageChange: (pictursList) => {
        console.log({ pictursList });
        this.setState({ pictursList });
      },
      productDescription: this.state.description,
      onChangeDescription: (description) => {
        console.log({ description });
        this.setState({ description });
      },
      info: info || {},
      onChangeUrl: this.onChangeUrl,
      searchProductUrl: "",
      searchUrlStatus: false,
      isEdit: false,
      onChangeSubCategory: (selectedSubCategory) => {
        this.setState({ selectedSubCategory, selectedSubCategoryError: false });
      },
      onChangeCategoryId: (categoryId, url) => {
        this.setState({
          selectedCategoryId: categoryId,
          selectedCategoryUrl: url,
          selectedCategoryError: false,
        });
      },
      categoryList: categoryList,
      onChangeBrandId: (brandId, url) => {
        this.setState({
          selectedBrandId: brandId,
          selectedBrandUrl: url,
          selectedBrandError: false,
        });
      },
      brandsList: brandsList,
      onClickActive: (active) => {
        this.setState({ active });
      },
      onClickConfirm: (data) => {
        console.log(data);
        this.addProductInfo(data);
      },
      pdfFileUrl: info.pdfFileUrl,
      onChangePdf: (pdfFileUrl) => {
        info["pdfFileUrl"] = pdfFileUrl;
        this.setState({ pdfFileUrl, info });
      },
      onChangePdfName: (pdfFileName) => {
        info["pdfFileName"] = pdfFileName;
        this.setState({ pdfFileName, info });
      },
      // productInfo: infoData,
    };

    return (
      <Fragment>
        <Breadcrumb title="Add" parent="Product" />
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <ProductInfo {...productInfoProps} />
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default CreateProduct;
